class Session
{
  constructor ()
  {
    this.prefix = 'donor-session-';
  }

  get (key)
  {
    if (!window.sessionStorage) {
      return null;
    }

    const data = window.sessionStorage.getItem(this.prefix + key);

    if (typeof(data) !== 'undefined' && data !== null && data.length) {
      const json = JSON.parse(data);
      const now = (new Date()).getTime();

      // Check cache time is valid
      if (typeof(json.ttl) !== 'undefined') {
        if (now - json.ttl < 0) {
          return json.data;
        }

        // Expired
        this.forget(this.prefix + key);
      } else {
        return json.data;
      }
    }

    return null;
  }

  put (key, obj, seconds)
  {
    if (!window.sessionStorage) {
      return;
    }

    const data = {
      data: obj
    };

    // Time to live for cache
    if (typeof(seconds) !== 'undefined') {
      data.ttl = (new Date()).getTime() + seconds * 1000;
    }

    window.sessionStorage.setItem(this.prefix + key, JSON.stringify(data));
  }

  forget (key)
  {
    if (!window.sessionStorage) {
      return;
    }

    window.sessionStorage.removeItem(this.prefix + key);
  }

  flush ()
  {
    if (!window.sessionStorage) {
      return;
    }

    for (let i = 0, len = window.sessionStorage.length; i < len; ++i) {
      if (window.sessionStorage.key(i) && window.sessionStorage.key(i).startsWith(this.prefix)) {
        window.sessionStorage.removeItem(window.sessionStorage.key(i));
      }
    }
  }
}